import { ActionTypes } from "../Constants/ActionTypes";

export const addVideoScheduleInformation = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.ADD_VIDEO_SCHEDULE_INFORMATION,
    payload: payload,
  });
};

export const resetVideoScheduleEventData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.RESET_VIDEO_SCHEDULE_EVENT_DATA,
    payload: payload,
  });
};

export const addPlaylistData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.ADD_PLAYLIST_DATA,
    payload: payload,
  });
};
